export function enforceMinMax(el: React.ChangeEvent<HTMLInputElement>) {
  if (el.target.value !== ``) {
    if (parseInt(el.target.value) < parseInt(el.target.min)) {
      el.target.value = el.target.min
    }
    if (parseInt(el.target.value) > parseInt(el.target.max)) {
      el.target.value = el.target.max
    }
  }
}
